import * as actionTypes from "../actions/actionTypes";

export const fetchQuestionsInit = (moduleName) => {
  return {
    type: actionTypes.FETCH_QUESTIONS_INIT,
    payload: { moduleName },
  };
};

export const fetchQuestionsInProgress = () => {
  return {
    type: actionTypes.FETCH_QUESTIONS_INPROGRESS,
  };
};

export const fetchQuestionsSuccess = (questions, moduleName) => {
  return {
    type: actionTypes.FETCH_QUESTIONS_SUCCESS,
    payload: { questions, moduleName },
  };
};

export const fetchQuestionsFailed = (error) => {
  return {
    type: actionTypes.FETCH_QUESTIONS_FAILED,
    payload: { error },
  };
};

export const questionsClearError = () => {
  return {
    type: actionTypes.QUESTIONS_CLEAR_ERROR,
  };
};
